import { type CountryCode, type ProjectCode } from '@constants'
import { type AmountGiveaway, type Bundles } from './bundles'
import { type Coupon } from './coupon'
import { type MemberLogins } from './fortuneCampaign'
import { type PaymentMethodType, type PaymentServiceType } from './payment'
import { type AllProduct } from './products'
import { type Delivery } from './shipping'

export enum CampaignStatus {
  TESTING = 'testing',
  IN_PROGRESS = 'in_progress',
  PAUSED = 'paused',
  NOT_YET = 'not_yet',
  EXPIRED = 'expired',
}

export interface Brand {
  brand_name: string
  brand_code: string
  brand_url: string
  brand_image: string
  project_code: ProjectCode
  company_name: string
}

export interface Campaign {
  title: string
  campaign_id: number
  site_id: number
  language: string
  decimal: number
  status: CampaignStatus
  currency: string
  tax_rate: number
  start_time: string
  end_time: string
  brand_codes_info: Brand[]
  available_regions: CountryCode[]
  search_keywords: string[]
  is_giveaway_dispatch: boolean
  giveaway_thumbnail: string
  payment_methods: {
    ordinal: number
    payment_option_type: PaymentMethodType
    payment_service_config_type: PaymentServiceType
  }[]
  enable_pickup_giveaway: boolean
  enable_delivery_giveaway: boolean
  enable_giveaway: boolean
  timezone_offset: string
  region: CountryCode
  member_login_type: MemberLogins
  announcement?: string
  email_domain?: string
  icons?: {
    project_code: ProjectCode
    icon_url: string
  }[]
  has_homepage: boolean
  homepage_name?: string
}

export interface CampaignsProduct {
  products: {
    tab_display_name: string
    coupon_ids: Coupon['id'][]
    all_product: AllProduct[]
  }[]
  bundles: Bundles | null
  delivery: Delivery[]
  additions: {
    coupon_ids: Coupon['id'][]
    all_product: AllProduct[]
    tab_display_name: string
  }[]
  gifts: AmountGiveaway[]
}

export interface CampaignsProduct2B {
  products: {
    tab_display_name: string
    coupon_ids: Coupon['id'][]
    all_product: AllProduct[]
  }[]
  additions: {
    coupon_ids: Coupon['id'][]
    all_product: AllProduct[]
    tab_display_name: string
  }[]
  delivery: Delivery[]
}

export interface CampaignMember {
  project_code: ProjectCode
  account: string
  roles: string[]
  platform_uid: string
  user_name?: string
}

type CampaignBannerType = 'banner' | 'thumbnails' | 'carousel'
type CampaignBannerDeviceType = 'pc' | 'mobile'
export interface CampaignBanner {
  type: CampaignBannerType
  title: string
  created_at: string
  updated_at: string
  images: {
    image_id: number
    device_type: CampaignBannerDeviceType
    url: string
    link_url?: string
  }[]
}
